module.exports = __webpack_public_path__ + "img/img1.88153f4f.jpg";